<template>
  <div class="compreende-wrapper">
    <div :class="['compreende-titulo', 'modal-label']">
      {{ titulo }}
    </div>
    <div
      class="compreende-conteudo"
      v-for="(item, index) in conteudoEditado.split('<br>')"
      :key="index"
    >
      {{
        item.charAt(0) == " "
          ? item.charAt(1).toUpperCase() + item.slice(2)
          : item.charAt(0).toUpperCase() + item.slice(1)
      }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BlocoCompreende",
  props: {
    titulo: String,
    conteudo: String
  },
  computed: {
    conteudoEditado() {
      if (this.conteudo) {
        let editado1 = this.conteudo.replace("Esta subclasse compreende:", "");
        let editado2 = editado1.replace("Esta subclasse não compreende:  <br>", "");
        let editado3 = editado2.replaceAll("-- ", "");
        let editado4 = editado3.replaceAll("- ", "");
        return editado4;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.compreende-wrapper {
  display: flex;
  flex-direction: column;
}
.compreende-titulo {
  display: flex;
  justify-content: center;
  padding: 0 10px 5px 10px;
  // border-bottom: 1px solid var(--cinza03);
}
.compreende-conteudo {
  font-size: 12px;
  padding: 5px 10px;
  // border-bottom: 1px solid var(--cinza03);
  &:nth-child(even) {
    background: #f6f6f6;
  }
}
</style>
